<template>
  <div>
    <field-group
      class="my-1"
      inline
      onlyColor
      :label="field.label"
      type-input="v-checkbox"
      v-model="form[field.value]"
      @change="onChangeGroup"
    ></field-group>
    <template v-if="form[field.value]">
      <ruleInput
        v-for="input of field.children"
        :typeInput="input.type"
        :label="input.label"
        :key="input.value"
        v-model="form[input.value]"
        :autocomplete="input.autocomplete"
        @input="onValueChildrenGroup()"
      ></ruleInput>
    </template>
  </div>
</template>

<script>
import ruleInput from './edit-rule-input.vue'
export default {
  components: { ruleInput },
  props: {
    field: { type: Object, require: true },
    value: { type: Object, require: true },
  },
  data: () => ({}),
  computed: {
    form: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    onChangeGroup(value) {
      this.$set(this.form, this.field.value, value)
      if (this.form[this.field.value]) {
        this.field.children.forEach((field) => {
          this.$set(this.form, field.value, field.defaultValue || '')
        })
      }
      this.$emit('input', this.form)
    },
    onValueChildrenGroup() {
      this.$emit('input', this.form)
    },
  },
}
</script>

<style scoped></style>
